// Preloader

/* eslint-disable wrap-iife */

/* global jQuery */

import gsap from 'gsap';

class DispatchSkinPreloader {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-preloader';
		this.logoSelector = `${this.selector}__logo`;
		this.hexagonsSelector = `${this.selector}__hexagons`;
		this.delay = 1500;
		this.activeClass = 'is-active';
		this.finishEvent = 'preloaderFinish';

		this.preloader = null;
		this.logo = null;
		this.timeline = null;
	}

	/**
	 * Initializes the class, sets up events for section-based scroll animations.
	 */
	initialize() {

		this.preloader = jQuery( this.selector );
		this.logo = jQuery( this.logoSelector );
		this.hexagons = jQuery( this.hexagonsSelector );

		if ( this.preloader.length ) {

			this.timeline = gsap.timeline()
				.to( this.logo, { duration: 0.75, ease: 'back.out(2)', scale: 1 } )
				.to( this.hexagons, { duration: 0.2, opacity: 0.5 } )
				.add(
					gsap.timeline( { repeat: -1 } )
						.to( this.logo, { duration: 0.15, scale: 0.95, repeat: 1, yoyo: true } )
						.to( this.hexagons.find( '.o-svg' ), { duration: 3, stagger: 0.6, opacity: 0, scale: 2 }, '<' ),
					'<'
				);

			window.setTimeout(
				this.animateOut.bind( this ),
				this.delay
			);
		}

		else {
			this.remove();
		}
	}

	/**
	 * Removes the preloader
	 */
	animateOut() {

		gsap.timeline()
			.to( this.logo, { duration: 0.3, scale: 0 } )
			.to( this.hexagons, { duration: 0.3, scale: 0 }, '<' )
			.to( this.preloader, { duration: 0.5, opacity: 0 } )
			.call(
				function() {
					this.timeline.pause();
					this.remove();
				}.bind( this ),
				[],
				'>-0.2'
			);
	}

	/**
	 * Removes
	 */
	remove() {
		this.preloader.removeClass( this.activeClass );
		jQuery( window ).trigger( this.finishEvent );
	}

}

const preloader = new DispatchSkinPreloader();
export default preloader;




// WEBPACK FOOTER //
// ./src/js/inc/preloader.js